import { FC } from "react";
import Form from "react-bootstrap/Form";

// date-fns
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { LocalizationProvider } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { DesktopDateTimePicker } from "@mui/x-date-pickers/DesktopDateTimePicker";
import moment from "moment";

interface IMatDatePicker {
  controlId: string;
  label: string;
  placeholder?: any;
  handleChange?: any;
  handleBlur?: any;
  errorsField?: any;
  touched?: any;
  value: any;
  setValue: any;
}

/**
 * Input Type Text Reusable Component
 *
 * @param {{ controlId: any; label: any; placeholder: any; handleChange: any; handleBlur: any; errorsField: any; touched: any; setValue: any }} {
    controlId, label, placeholder, handleChange, handleBlur, errorsField, touched
}
 * @returns {*}
 */
const MatDatePicker: FC<IMatDatePicker> = ({
  controlId,
  label,
  placeholder,
  handleChange,
  handleBlur,
  errorsField,
  touched,
  value,
  setValue,
}) => {
  const today = moment();

  return (
    <FormControl fullWidth error={errorsField && touched}>
      <Form.Group className="mb-3 pb-1" controlId={controlId}>
        <div className="position-relative date-picker-icon">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DemoContainer
              components={["DateTimePicker", "DesktopDateTimePicker"]}
            >
              <DemoItem label=" ">
                <DateTimePicker
                  views={["year", "month", "day", "hours", "minutes"]}
                  className="w-100 customDatePickerIcon"
                  value={value}
                  label={label}
                  onChange={(e) => {
                    handleChange(e);
                    setValue(e);
                  }}
                  // onError={errorsField}
                  slotProps={{
                    textField: {
                      helperText: errorsField,
                    },
                  }}
                  defaultValue={value}
                />
              </DemoItem>
            </DemoContainer>
          </LocalizationProvider>
          {/*<FormHelperText>{errorsField && touched?errorsField:""}</FormHelperText>*/}
          <Form.Control.Feedback type="invalid">
            {errorsField}
          </Form.Control.Feedback>
        </div>
      </Form.Group>
    </FormControl>
  );
};

export default MatDatePicker;
